import Vue from 'vue';
import Buefy from 'buefy';

Vue.use(Buefy, {
  defaultToastDuration: 3000,
  defaultToastPosition: 'is-bottom',
});
